import React from "react";
import { FileSpreadsheet, FileArchive } from "lucide-react";

const deliverables = [
  {
    icon: <FileSpreadsheet size={22} />,
    title: "Financial Statements (Excel)",
    points: [
      "Latest available financial years",
      "Profit & Loss, Balance Sheet and Cash Flow statements",
      "Consolidated and Standalone, where filed",
      "Company profile: industry, sector, address, auditor and more",
      "All figures in INR Crore"
    ]
  },
  {
    icon: <FileArchive size={22} />,
    title: "Annual Reports (ZIP)",
    points: [
      "The company's annual reports as filed with the MCA",
      "Bundled in a single ZIP download"
    ]
  }
];

const WhatYouGet = () => {
  return (
    <section className="bg-gray-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-center text-3xl font-semibold mb-12">What you get for each company</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {deliverables.map((item, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-md border border-gray-200">
              <div className="flex items-center gap-3 mb-6">
                <div className="bg-[#c59c40] rounded-lg p-2 text-white">{item.icon}</div>
                <h3 className="text-2xl font-bold text-gray-800">{item.title}</h3>
              </div>
              <ul className="space-y-4">
                {item.points.map((point, idx) => (
                  <li key={idx} className="flex items-start space-x-3">
                    <span className="h-2 w-2 bg-[#bc8b20] rounded-full mt-2 flex-shrink-0" />
                    <p className="text-gray-600">{point}</p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatYouGet;
